import numeral from "numeral";
import React from "react";
import styles from "./CommonCellRenderers.module.scss";
import { InlineLoader } from "./../Loaders";
import classNames from "classnames";
import _ from "lodash";
import NotAvailableCellData from './NotAvailableCellData'
import { AzureIcon, GcpIcon, AwsIcon, OnpremIcon, AwsCircleIcon, AzureCircleIcon, GcpCircleIcon, OnpremCircleIcon } from "../../../icons/custom";

const CommonCellRenderers = {};

export default CommonCellRenderers;

CommonCellRenderers.CapacityRenderer = ({ value }) => {
    return <span>
        {numeral(value).format("0,0.[00] ib")}
    </span>
}

CommonCellRenderers.CapacityRendererTiB = ({ value }) => {
    return <span>
        {numeral(value / 1024 / 1024 / 1024 / 1024).format("0,0.[00]")}
    </span>
}

CommonCellRenderers.CapacityRendererGib = ({ value }) => {
    return <span>
        {numeral(value / 1024 / 1024 / 1024).format("0,0.[00]")}
    </span>
}

CommonCellRenderers.StatusRenderer = (statusesMap) => ({ value }) => {
    let status = statusesMap[value];
    if (_.isString(status)) {
        status = {
            classname: status,
            label: value,
            isLoadingStatus: status === "loading"
        }
    }
    if (status) {
        return <div className={styles["status"]}>
                    {status.isLoadingStatus ? <InlineLoader className={styles["loader"]}/> : <span className={classNames(styles["circle"], styles[status.classname])}/>}
                    <span className={classNames(styles["text"], styles[status.classname])}>{status.label}</span>
                </div>
    } else {
        return <div className={styles["status"]}>
                    <span className={classNames(styles["text"])}>{value}</span>
                </div>
    }
    
}
CommonCellRenderers.NotAvailableCellData = NotAvailableCellData

CommonCellRenderers.RowClickCellButton = label => () => {
    return <div className={styles['cta']}>
        {label}
    </div>
}

CommonCellRenderers.PopoverRenderer = Contents => row => {
    return <div className={styles["popover-renderer"]}>
        <Contents {...row}/>
    </div>
}

CommonCellRenderers.TwoItemRenderer = Contents => row => {
    return <div className={styles["two-item-renderer"]}>
        <Contents {...row}/>
    </div>
}

const providersMap = {
    aws: { icon: AwsIcon, circleIcon: AwsCircleIcon, tableIconClassName: styles['aws-icon'] },
    azure: { icon: AzureIcon, circleIcon: AzureCircleIcon, tableIconClassName: styles['azure-icon'] },
    gcp: { icon: GcpIcon, circleIcon: GcpCircleIcon, tableIconClassName: styles['gcp-icon'] },
    "on-prem": { icon: OnpremIcon, circleIcon: OnpremCircleIcon, tableIconClassName: styles['on-prem-icon'] }
};

CommonCellRenderers.ProviderRenderer = ({ value }) => {
    const Icon = providersMap[value]?.icon;
    const className = providersMap[value]?.tableIconClassName;
    return Icon ? <Icon className={className}/> : <NotAvailableCellData/>;
}

CommonCellRenderers.ProviderCircleRenderer = ({ value }) => {
    const Icon = providersMap[value]?.circleIcon;
    return Icon ? <Icon className={styles["provider-circle-icon"]}/> : <NotAvailableCellData/>;
}
